const SparkleIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="#15415E" aria-hidden>
    <path d="M12 2l2.5 6.5L21 11l-6.5 2.5L12 20l-2.5-6.5L3 11l6.5-2.5L12 2z" />
  </svg>
);

const FEATURES = [
  "Flexible packages based on your hiring volume & employer brand needs",
  "Annual renewable agreement",
  "Marketing & Brand Activation Opportunities",
  "Dedicated sales & marketing support for pricing and scaling options",
  "BONUS: Free 1 Hr Military Spouse Brand Consultation",
];

export default function ContactSalesSupport({
  onContactSales,
}: any) {
  return (
    <div className="flex w-full max-w-[520px] mx-auto flex-col items-center text-center bg-white font-sans">
      <h2 className="text-[20px] sm:text-[22px] font-bold text-[#15415E] text-center leading-snug w-full">
        Thanks for being a part of the Instant Teams Marketplace!
      </h2>

      <p className="mt-3 sm:mt-3.5 text-[13px] sm:text-sm text-[#8AA0AE] text-center w-full leading-relaxed">
        You’re currently set up with a custom annual hiring package built to fit
        your organization’s needs through our job board.
      </p>

      <div className="relative w-full mt-7 sm:mt-8 border border-[#15415E]/25 rounded-[18px] bg-[#F8FBFD] px-5 sm:px-7 pt-8 pb-6 text-left">
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#15415E] text-white text-[10px] font-bold tracking-widest px-3.5 py-1 rounded-full whitespace-nowrap">
          Your Current Plan
        </div>

        <div className="text-lg sm:text-xl font-bold text-[#15415E] mb-4 sm:mb-5">
          Annual Custom Plan
        </div>

        <ul className="flex flex-col gap-3">
          {FEATURES.map((feature, i) => (
            <li
              key={i}
              className="flex items-start gap-2.5 text-[13px] leading-snug text-[#15415E]"
            >
              <span className="mt-[2px] shrink-0">
                <SparkleIcon />
              </span>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      <button
        type="button"
        onClick={onContactSales}
        className="mt-6 sm:mt-7 w-full py-3.5 rounded-full bg-[#15415E] text-white text-[14px] sm:text-[15px] font-semibold shadow-[0_8px_20px_-8px_rgba(21,65,94,0.55)] hover:bg-[#1d5278] active:bg-[#123348] active:scale-[0.99] transition-all duration-200"
      >
        Connect with our team to discuss your plan
      </button>
    </div>
  );
}
